// Entreprise dans laquelle l'utilisateur travaille (sélecteur d'entreprise du Header), lisible
// hors React par les services qui appellent les edge functions. Tenue à jour par
// DashboardContext. Le SERVEUR ne la croit jamais sur parole : il ne l'applique que si
// l'utilisateur en est membre, sinon il retombe sur la 1re adhésion (comportement historique).
let active: string | null = null;

export function setActiveEnterpriseId(id: string | null | undefined): void {
  const v = typeof id === 'string' ? id.trim() : '';
  active = v || null;
}

export function getActiveEnterpriseId(): string | null {
  return active;
}
